export function addMissingAlt () {
    const images = document.querySelectorAll('img')
    images.forEach(image => {
      const hasNoAlt = !image.hasAttribute('alt')
      if (hasNoAlt) {
        image.setAttribute('alt', '')
      }
    })
  }
  